import { useEffect } from 'react';
// #region agent log
// fetch('http://localhost:7242/ingest/7fbf4cdb-0330-43f8-bafc-0875e47882a3',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CircularText.jsx:2',message:'Importing framer-motion',data:{},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
// #endregion
import { motion, useAnimation, useMotionValue } from 'framer-motion';

import './CircularText.css';

const getRotationTransition = (duration, from, loop = true) => ({
  from,
  to: from + 360,
  ease: 'linear',
  duration,
  type: 'tween',
  repeat: loop ? Infinity : 0
});

const getTransition = (duration, from) => ({
  rotate: getRotationTransition(duration, from),
  scale: {
    type: 'spring',
    damping: 20,
    stiffness: 300
  }
});

const CircularText = ({ text, spinDuration = 20, onHover = 'speedUp', className = '' }) => {
  // #region agent log
  // fetch('http://localhost:7242/ingest/7fbf4cdb-0330-43f8-bafc-0875e47882a3',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CircularText.jsx:24',message:'CircularText component render start',data:{text,spinDuration,onHover,className},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'E'})}).catch(()=>{});
  // #endregion
  const letters = Array.from(text);
  // #region agent log
  // fetch('http://localhost:7242/ingest/7fbf4cdb-0330-43f8-bafc-0875e47882a3',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CircularText.jsx:31',message:'Before useAnimation/useMotionValue',data:{lettersCount:letters.length},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
  // #endregion
  const controls = useAnimation();
  const rotation = useMotionValue(0);
  // #region agent log
  // fetch('http://localhost:7242/ingest/7fbf4cdb-0330-43f8-bafc-0875e47882a3',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CircularText.jsx:35',message:'useAnimation/useMotionValue called',data:{hasControls:!!controls,hasRotation:!!rotation},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
  // #endregion

  useEffect(() => {
    // #region agent log
    // fetch('http://localhost:7242/ingest/7fbf4cdb-0330-43f8-bafc-0875e47882a3',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CircularText.jsx:40',message:'useEffect start',data:{hasRotation:!!rotation,hasControls:!!controls},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'E'})}).catch(()=>{});
    // #endregion
    try {
      const start = rotation.get();
      // #region agent log
      // fetch('http://localhost:7242/ingest/7fbf4cdb-0330-43f8-bafc-0875e47882a3',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CircularText.jsx:43',message:'Before controls.start',data:{start,spinDuration},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
      // #endregion
      controls.start({
        rotate: start + 360,
        scale: 1,
        transition: getTransition(spinDuration, start)
      });
      // #region agent log
      // fetch('http://localhost:7242/ingest/7fbf4cdb-0330-43f8-bafc-0875e47882a3',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CircularText.jsx:50',message:'controls.start called successfully',data:{},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
      // #endregion
    } catch(e) {
      // #region agent log
      // fetch('http://localhost:7242/ingest/7fbf4cdb-0330-43f8-bafc-0875e47882a3',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CircularText.jsx:53',message:'useEffect error',data:{error:e.message,stack:e.stack},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
      // #endregion
    }
  }, [spinDuration, text, onHover, controls, rotation]);

  const handleHoverStart = () => {
    const start = rotation.get();
    console.log('CircularText mounted with text:', text);
    if (!onHover) return;

    let transitionConfig;
    let scaleVal = 1;

    switch (onHover) {
      case 'slowDown':
        transitionConfig = getTransition(spinDuration * 2, start);
        break;
      case 'speedUp':
        transitionConfig = getTransition(spinDuration / 4, start);
        break;
      case 'pause':
        transitionConfig = {
          rotate: { type: 'spring', damping: 20, stiffness: 300 },
          scale: { type: 'spring', damping: 20, stiffness: 300 }
        };
        scaleVal = 1;
        break;
      case 'goBonkers':
        transitionConfig = getTransition(spinDuration / 20, start);
        scaleVal = 0.8;
        break;
      default:
        transitionConfig = getTransition(spinDuration, start);
    }

    controls.start({
      rotate: start + 360,
      scale: scaleVal,
      transition: transitionConfig
    });
  };

  const handleHoverEnd = () => {
    const start = rotation.get();
    controls.start({
      rotate: start + 360,
      scale: 1,
      transition: getTransition(spinDuration, start)
    });
  };

  return (
    <motion.div
      className={`circular-text ${className}`}
      style={{ rotate: rotation }}
      initial={{ rotate: 0 }}
      animate={controls}
      onMouseEnter={handleHoverStart}
      onMouseLeave={handleHoverEnd}
    >
      {letters.map((letter, i) => {
        const rotationDeg = (360 / letters.length) * i;
        const factor = Math.PI / letters.length;
        const x = factor * i;
        const y = factor * i;
        const transform = `rotateZ(${rotationDeg}deg) translate3d(${x}px, ${y}px, 0)`;

        return (
          <span key={i} style={{ transform, WebkitTransform: transform }}>
            {letter}
          </span>
        );
      })}
    </motion.div>
  );
};

export default CircularText;

